<script setup lang="ts">
import { computed, ref } from 'vue';
import { useTenantStore } from '/@stores/tenant';

const model = defineModel<Set<string>>();

const props = defineProps<{
  initialGuid: string;
}>();

const tenantStore = useTenantStore();
const selectedUserIds = ref<Set<number>>(new Set());
const userSearchModel = ref('');

const filteredUsers = computed(() =>
  [...tenantStore.users.values()].filter((user) =>
    user.name.toLowerCase().includes(userSearchModel.value.toLowerCase()),
  ),
);

function toggleUser(id: number) {
  const next = new Set(selectedUserIds.value);
  next.has(id) ? next.delete(id) : next.add(id);
  selectedUserIds.value = next;
  model.value = new Set(
    [...next]
      .map((userId) => tenantStore.users.get(userId)?.guid)
      .filter((guid): guid is string => !!guid),
  );
}

tenantStore.loadUsers().then(() => {
  const user = [...tenantStore.users.values()].find((u) => u.guid === props.initialGuid);
  if (user) {
    selectedUserIds.value = new Set([user.id]);
    model.value = new Set([user.guid]);
  } else {
    model.value = new Set();
  }
});
</script>

<template>
  <df-select class="dl__group dl__group--large" label="Brukere" v-on:open="userSearchModel = ''">
    <template v-slot:text>
      {{
        [...selectedUserIds]
          .map((id) => tenantStore.users.get(id)?.name ?? 'ukjent bruker')
          .join(', ')
      }}
    </template>
    <div>
      <df-input-search v-model="userSearchModel" class="user-menu_input" />
      <df-dropdown2-item
        v-for="user in filteredUsers"
        :key="user.id"
        v-on:click="toggleUser(user.id)"
        no-close
      >
        <div class="listitem">
          <df-icon :code="selectedUserIds.has(user.id) ? 'f14a' : 'f0c8'" />
          <div>{{ user.name }}</div>
        </div>
      </df-dropdown2-item>
    </div>
  </df-select>
</template>

<style scoped>
.listitem {
  display: grid;
  gap: var(--gap-md);
  grid-template-columns: max-content 1fr;
  align-items: center;
}

.user-menu_input {
  padding: var(--gap-md);
}
</style>
